export default "__VITE_ASSET__CdbKZ8Sz__"